import { render, staticRenderFns } from "./audit-upload-card.vue?vue&type=template&id=72a638d6&scoped=true"
import script from "./audit-upload-card.vue?vue&type=script&lang=js"
export * from "./audit-upload-card.vue?vue&type=script&lang=js"
import style0 from "./audit-upload-card.vue?vue&type=style&index=0&id=72a638d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a638d6",
  null
  
)

export default component.exports